import React from "react";
import chevronDown from "@/assets/icons/chevronDown.svg";
interface StoreList {
  id: string;
  name: string;
  state: string;
}
interface DropdownProps {
  options: StoreList[];
  selectedValue: string | any;
  onOptionChange: (value: string) => void;
  isDarkMode?: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({
  options,
  selectedValue,
  onOptionChange,
  isDarkMode = false
}) => {
  return (
    <div className="relative inline-block">
      <select
        value={selectedValue}
        onChange={(e) => {
          onOptionChange(e.target.value)
        }}
        className={`appearance-none ${isDarkMode ? 'bg-black text-white' : 'bg-white'} rounded-full px-5 py-3 pr-8 text-sm focus:outline-none`}
      >
        {options?.map((option, index) => {
          return (
            <option
              key={index}
              value={option.name}
              className={isDarkMode ? 'bg-white text-black' : ''}>
              {`${option.name.charAt(0).toUpperCase() + option.name.slice(1)}${option.state !== 'btc' ? ` (${option.state})` : ''}`}
            </option>
          )
        })}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-500">
        <img src={chevronDown} className={`${isDarkMode && 'invert'}`} />
      </div>
    </div>
  );
};

export default Dropdown;
